// extracted by mini-css-extract-plugin
module.exports = {"faqAccordion":"FAQ_faqAccordion__lX6FQ","faqWrapper":"FAQ_faqWrapper__9V6U9","colWrapper":"FAQ_colWrapper__cYupJ","faqContent":"FAQ_faqContent__EQWCA"};